import React from "react";
import { useHistory } from "react-router-dom";

import { Button, CircularProgress, Typography } from "@mui/material";
import { Box } from "@mui/system";

import SelectField from "../Components/SelectField";
import TextFieldCom from "../Components/TextField";

import Axios from "../hooks/Axios";

const Setting = () => {
  const { response, loading, error } = Axios({ url: "/api_category.php" });

  const history = useHistory();

  if (loading) {
    return (
      <Box mt={20}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography variant="h6" mt={20} color="red">
        Something went wrong!!
      </Typography>
    );
  }

  const difficultyOption = [
    { id: "easy", name: "Easy" },
    { id: "medium", name: "Medium" },
    { id: "hard", name: "Hard" },
  ];

  const typeOptions = [
    { id: "multiple", name: "Multiple choice" },
    { id: "boolean", name: "True or False" },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    history.push("/question");
  };

  return (
    <form onSubmit={handleSubmit}>
      <SelectField options={response.trivia_categories} label="Select Category" />
      <SelectField options={difficultyOption} label="Select Difficulty level" />
      <SelectField options={typeOptions} label="Select Type" />
      <TextFieldCom />
      <Box mt={3} width="100%">
        <Button fullWidth variant="contained" type="submit" style={{backgroundColor:"red", marginBottom:"20px"}} >
          Start Quiz
        </Button>
      </Box>
    </form>
  );
};

export default Setting;
